// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Antd = require("antd");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Head = require("next/head").default;
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Router = require("next/router");
var Script = require("next/script").default;
var Intl$SmartcutsMacros = require("../../packages/bs-utils/src/Intl.bs.js");
var Next$SmartcutsMacros = require("../bindings/Next.bs.js");
var Apollo$SmartcutsMacros = require("../../packages/data/src/Apollo.bs.js");
var AppConfig$SmartcutsMacros = require("./AppConfig.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../packages/bs-utils/src/ArrayUtils.bs.js");
var ReactUtils$SmartcutsMacros = require("../../packages/bs-utils/src/ReactUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../packages/bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../packages/bs-utils/src/StringUtils.bs.js");
var ErrorMessage$SmartcutsMacros = require("./ErrorMessage.bs.js");
var LayoutPublic$SmartcutsMacros = require("../components/LayoutPublic.bs.js");
var WithIdentity$SmartcutsMacros = require("./WithIdentity.bs.js");
var LoadingSpinner$SmartcutsMacros = require("../components/LoadingSpinner.bs.js");
var DataStore__User$SmartcutsMacros = require("../../packages/data/src/DataStore__User.bs.js");
var StripeUX__CheckoutButton$SmartcutsMacros = require("../components/StripeUX__CheckoutButton.bs.js");
var StripeUX__ManageSubscriptionButton$SmartcutsMacros = require("../components/StripeUX__ManageSubscriptionButton.bs.js");

var page = Curry._1(Css.style, {
      hd: Css.minHeight({
            NAME: "vh",
            VAL: 100.0
          }),
      tl: {
        hd: Css.minWidth({
              NAME: "vw",
              VAL: 100.0
            }),
        tl: {
          hd: Css.background({
                NAME: "hex",
                VAL: "f2f2f2"
              }),
          tl: {
            hd: Css.selector(".pageContent", {
                  hd: Css.minHeight({
                        NAME: "vh",
                        VAL: 100.0
                      }),
                  tl: {
                    hd: Css.width({
                          NAME: "percent",
                          VAL: 100.0
                        }),
                    tl: {
                      hd: Css.maxWidth({
                            NAME: "px",
                            VAL: 1000
                          }),
                      tl: {
                        hd: Css.margin("auto"),
                        tl: {
                          hd: Css.boxSizing("borderBox"),
                          tl: {
                            hd: Css.padding({
                                  NAME: "px",
                                  VAL: 20
                                }),
                            tl: {
                              hd: Css.background({
                                    NAME: "hex",
                                    VAL: "fff"
                                  }),
                              tl: {
                                hd: Css.selector(".headline", {
                                      hd: Css.textAlign("center"),
                                      tl: {
                                        hd: Css.margin2({
                                              NAME: "px",
                                              VAL: 20
                                            }, "zero"),
                                        tl: {
                                          hd: Css.selector("h1", {
                                                hd: Css.fontSize({
                                                      NAME: "px",
                                                      VAL: 30
                                                    }),
                                                tl: {
                                                  hd: Css.marginBottom({
                                                        NAME: "px",
                                                        VAL: 10
                                                      }),
                                                  tl: /* [] */0
                                                }
                                              }),
                                          tl: /* [] */0
                                        }
                                      }
                                    }),
                                tl: {
                                  hd: Css.selector(".allPlans", {
                                        hd: Css.display("flex"),
                                        tl: {
                                          hd: Css.flexDirection("row"),
                                          tl: {
                                            hd: Css.justifyContent("center"),
                                            tl: {
                                              hd: Css.flexWrap("wrap"),
                                              tl: {
                                                hd: Css.selector(".servicePlan", {
                                                      hd: Css.width({
                                                            NAME: "px",
                                                            VAL: 300
                                                          }),
                                                      tl: {
                                                        hd: Css.margin({
                                                              NAME: "px",
                                                              VAL: 5
                                                            }),
                                                        tl: {
                                                          hd: Css.selector(".ant-card-body", {
                                                                hd: Css.height({
                                                                      NAME: "percent",
                                                                      VAL: 100.0
                                                                    }),
                                                                tl: {
                                                                  hd: Css.display("flex"),
                                                                  tl: {
                                                                    hd: Css.flexDirection("column"),
                                                                    tl: /* [] */0
                                                                  }
                                                                }
                                                              }),
                                                          tl: {
                                                            hd: Css.selector("h2", {
                                                                  hd: Css.fontWeight("semiBold"),
                                                                  tl: {
                                                                    hd: Css.textTransform("uppercase"),
                                                                    tl: /* [] */0
                                                                  }
                                                                }),
                                                            tl: {
                                                              hd: Css.selector(".manageSubscription", {
                                                                    hd: Css.color({
                                                                          NAME: "hex",
                                                                          VAL: "1890ff"
                                                                        }),
                                                                    tl: {
                                                                      hd: Css.position("absolute"),
                                                                      tl: {
                                                                        hd: Css.right({
                                                                              NAME: "px",
                                                                              VAL: 24
                                                                            }),
                                                                        tl: {
                                                                          hd: Css.top({
                                                                                NAME: "px",
                                                                                VAL: 24
                                                                              }),
                                                                          tl: {
                                                                            hd: Css.padding("zero"),
                                                                            tl: /* [] */0
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }),
                                                              tl: {
                                                                hd: Css.selector(".servicePlanDetails, .servicePlanDetails > *", {
                                                                      hd: Css.margin2({
                                                                            NAME: "px",
                                                                            VAL: 10
                                                                          }, "zero"),
                                                                      tl: {
                                                                        hd: Css.color({
                                                                              NAME: "hex",
                                                                              VAL: "333"
                                                                            }),
                                                                        tl: /* [] */0
                                                                      }
                                                                    }),
                                                                tl: {
                                                                  hd: Css.selector("ul.features", {
                                                                        hd: Css.paddingLeft({
                                                                              NAME: "px",
                                                                              VAL: 15
                                                                            }),
                                                                        tl: /* [] */0
                                                                      }),
                                                                  tl: {
                                                                    hd: Css.selector(".billed", {
                                                                          hd: Css.color({
                                                                                NAME: "hex",
                                                                                VAL: "27ae60"
                                                                              }),
                                                                          tl: /* [] */0
                                                                        }),
                                                                    tl: {
                                                                      hd: Css.selector(".subscriptionPrice", {
                                                                            hd: Css.fontSize({
                                                                                  NAME: "px",
                                                                                  VAL: 24
                                                                                }),
                                                                            tl: {
                                                                              hd: Css.fontWeight("semiBold"),
                                                                              tl: /* [] */0
                                                                            }
                                                                          }),
                                                                      tl: {
                                                                        hd: Css.selector(".billed, .subscriptionPrice", {
                                                                              hd: Css.display("block"),
                                                                              tl: {
                                                                                hd: Css.textAlign("right"),
                                                                                tl: /* [] */0
                                                                              }
                                                                            }),
                                                                        tl: {
                                                                          hd: Css.selector(".actions", {
                                                                                hd: Css.justifySelf("flexEnd"),
                                                                                tl: {
                                                                                  hd: Css.marginTop("auto"),
                                                                                  tl: {
                                                                                    hd: Css.selector("& button, & a", {
                                                                                          hd: Css.width({
                                                                                                NAME: "percent",
                                                                                                VAL: 100.0
                                                                                              }),
                                                                                          tl: {
                                                                                            hd: Css.marginTop({
                                                                                                  NAME: "px",
                                                                                                  VAL: 10
                                                                                                }),
                                                                                            tl: {
                                                                                              hd: Css.selector("&.currentPlan[disabled]", {
                                                                                                    hd: Css.background({
                                                                                                          NAME: "hex",
                                                                                                          VAL: "27ae60"
                                                                                                        }),
                                                                                                    tl: {
                                                                                                      hd: Css.color({
                                                                                                            NAME: "hex",
                                                                                                            VAL: "fff"
                                                                                                          }),
                                                                                                      tl: {
                                                                                                        hd: Css.borderColor({
                                                                                                              NAME: "hex",
                                                                                                              VAL: "219653"
                                                                                                            }),
                                                                                                        tl: /* [] */0
                                                                                                      }
                                                                                                    }
                                                                                                  }),
                                                                                              tl: /* [] */0
                                                                                            }
                                                                                          }
                                                                                        }),
                                                                                    tl: /* [] */0
                                                                                  }
                                                                                }
                                                                              }),
                                                                          tl: /* [] */0
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }),
                                                tl: /* [] */0
                                              }
                                            }
                                          }
                                        }
                                      }),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }),
            tl: /* [] */0
          }
        }
      }
    });

var pageLoader = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexDirection("row"),
        tl: {
          hd: Css.selector(".loader", {
                hd: Css.padding({
                      NAME: "px",
                      VAL: 30
                    }),
                tl: {
                  hd: Css.margin("auto"),
                  tl: {
                    hd: Css.justifySelf("center"),
                    tl: {
                      hd: Css.textAlign("center"),
                      tl: {
                        hd: Css.color({
                              NAME: "hex",
                              VAL: "828282"
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }),
          tl: /* [] */0
        }
      }
    });

var Style = {
  page: page,
  pageLoader: pageLoader
};

function PagePlans$PageLoader(Props) {
  return React.createElement("section", {
              className: pageLoader
            }, React.createElement("div", {
                  className: "loader"
                }, React.createElement(LoadingSpinner$SmartcutsMacros.make, {}), React.createElement("div", undefined, ReactUtils$SmartcutsMacros.s("Loading"))));
}

var PageLoader = {
  make: PagePlans$PageLoader
};

function PagePlans$PriceInfoOrBilledStatus(Props) {
  var price = Props.price;
  return React.createElement(React.Fragment, undefined, price > 0 ? React.createElement("label", {
                    className: "billed"
                  }, ReactUtils$SmartcutsMacros.s("Billed monthly")) : null, React.createElement("label", {
                  className: "subscriptionPrice"
                }, ReactUtils$SmartcutsMacros.s(price === -1 ? "" : StringUtils$SmartcutsMacros.currencyFormat.format(price / 100.0))));
}

var PriceInfoOrBilledStatus = {
  make: PagePlans$PriceInfoOrBilledStatus
};

function PagePlans$PlanCard(Props) {
  var plan = Props.plan;
  var user = Props.user;
  var currentSubscription = Props.currentSubscription;
  var router = Router.useRouter();
  var servicePlanId = plan._id;
  var title = plan.name;
  var description = plan.description;
  var price = plan.subscriptionPrice;
  var executionSteps;
  if (plan.executionSteps === -1) {
    executionSteps = "Unlimited";
  } else {
    var arg = {};
    executionSteps = (function (param) {
            return new (Intl.NumberFormat)(param, arg);
          })(Intl$SmartcutsMacros.Locale.enUS).format(plan.executionSteps);
  }
  var tmp;
  if (currentSubscription !== undefined && !(price === -1 || price === 0 || currentSubscription.servicePlan.subscriptionPrice === 0)) {
    var arg$1 = currentSubscription.stripeCustomerId;
    var tmp$1;
    if (currentSubscription.servicePlan._id === servicePlanId) {
      tmp$1 = "Manage";
    } else {
      var arg$2 = currentSubscription.subtotal;
      tmp$1 = price < (function (param) {
            return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
          })("Expected subscription subtotal") ? "Downgrade" : "Upgrade";
    }
    tmp = React.createElement(StripeUX__ManageSubscriptionButton$SmartcutsMacros.make, {
          stripeCustomerId: (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
              })("Expect subscription.stripeCustomerId if subscription.price > 0"),
          router: router,
          children: ReactUtils$SmartcutsMacros.s(tmp$1)
        });
  } else {
    tmp = null;
  }
  return React.createElement(Antd.Card, {
              className: "servicePlan",
              children: null
            }, tmp, React.createElement("h2", undefined, ReactUtils$SmartcutsMacros.s(title)), React.createElement("div", {
                  className: "servicePlanDetails"
                }, React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s(description)), React.createElement("ul", {
                      className: "features"
                    }, React.createElement("li", undefined, ReactUtils$SmartcutsMacros.s("" + executionSteps + " smartcut steps per month")))), React.createElement("section", {
                  className: "actions"
                }, React.createElement(PagePlans$PriceInfoOrBilledStatus, {
                      price: price
                    }), React.createElement(StripeUX__CheckoutButton$SmartcutsMacros.make, {
                      servicePlanId: servicePlanId,
                      price: price,
                      user: user,
                      currentSubscription: currentSubscription
                    })));
}

var PlanCard = {
  make: PagePlans$PlanCard
};

function PagePlans$AllPlans(Props) {
  var allPlans = Props.allPlans;
  var user = Props.user;
  var currentSubscription = Props.currentSubscription;
  React.useEffect((function () {
          if (user !== undefined) {
            var email = user.email;
            var userId = user.userId;
            if (currentSubscription !== undefined) {
              var plan = currentSubscription.servicePlan.name;
              var isPaying = Belt_Option.map(currentSubscription.subtotal, (function (subtotal) {
                      return subtotal > 0;
                    }));
              var tmp = {
                email: email,
                plan: plan
              };
              if (isPaying !== undefined) {
                tmp.paying = Caml_option.valFromOption(isPaying);
              }
              window.analytics.identify(userId, tmp);
              var tmp$1 = {
                email: email,
                plan: plan
              };
              if (isPaying !== undefined) {
                tmp$1.isPaying = Caml_option.valFromOption(isPaying);
              }
              window.freshpaint.identify(userId, tmp$1);
            } else {
              window.analytics.identify(userId, {
                    email: email
                  });
              window.freshpaint.identify(userId, {
                    email: email
                  });
            }
          }
          
        }), []);
  return React.createElement("section", {
              className: "allPlans"
            }, Belt_Array.map(ArrayUtils$SmartcutsMacros.sort2(allPlans, (function (planA, planB) {
                        if (planA.executionSteps === -1) {
                          return 1;
                        } else if (planB.executionSteps === -1 || planA.executionSteps < planB.executionSteps) {
                          return -1;
                        } else if (planA.executionSteps > planB.executionSteps) {
                          return 1;
                        } else {
                          return 0;
                        }
                      })), (function (plan) {
                    return React.createElement(PagePlans$PlanCard, {
                                plan: plan,
                                user: user,
                                currentSubscription: currentSubscription,
                                key: plan._id
                              });
                  })));
}

var AllPlans = {
  make: PagePlans$AllPlans
};

function PagePlans(Props) {
  return WithIdentity$SmartcutsMacros.make(function (userIdentity) {
              var router = Router.useRouter();
              var match = Curry.app(DataStore__User$SmartcutsMacros.AllServicePlans.use, [
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                  ]);
              var match$1 = Curry.app(DataStore__User$SmartcutsMacros.MyActiveSubscriptions.use, [
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                  ]);
              var response = match.data;
              var error = match.error;
              var tmp;
              if (match.loading) {
                tmp = React.createElement(PagePlans$PageLoader, {});
              } else if (error !== undefined) {
                tmp = React.createElement(ErrorMessage$SmartcutsMacros.make, {
                      error: error.message
                    });
              } else if (response !== undefined) {
                var allPlans = Belt_Array.keepMap(response.allServicePlans.data, (function (x) {
                        return x;
                      }));
                if (userIdentity !== undefined) {
                  var match$2 = match$1.data;
                  var error$1 = match$1.error;
                  if (match$1.loading) {
                    tmp = React.createElement(PagePlans$PageLoader, {});
                  } else if (error$1 !== undefined) {
                    tmp = React.createElement(React.Fragment, undefined, React.createElement(PagePlans$AllPlans, {
                              allPlans: allPlans
                            }), React.createElement(ErrorMessage$SmartcutsMacros.make, {
                              error: error$1.message
                            }));
                  } else if (match$2 !== undefined) {
                    var subscriptionData = match$2.myActiveSubscriptions.data;
                    if (subscriptionData.length > 1) {
                      console.warn("Found > 1 active subscriptions; only expected 1", subscriptionData);
                    }
                    var currentSubscription = Belt_Option.flatMap(Belt_Array.get(subscriptionData, 0), (function (x) {
                            return x;
                          }));
                    var tmp$1 = {
                      allPlans: allPlans,
                      user: userIdentity
                    };
                    if (currentSubscription !== undefined) {
                      tmp$1.currentSubscription = Caml_option.valFromOption(currentSubscription);
                    }
                    tmp = React.createElement(PagePlans$AllPlans, tmp$1);
                  } else {
                    tmp = React.createElement(PagePlans$AllPlans, {
                          allPlans: allPlans,
                          user: userIdentity
                        });
                  }
                } else {
                  tmp = React.createElement(PagePlans$AllPlans, {
                        allPlans: allPlans
                      });
                }
              } else {
                tmp = React.createElement("div", undefined, ReactUtils$SmartcutsMacros.s("Nothing to see here."));
              }
              return React.createElement(LayoutPublic$SmartcutsMacros.make, {
                          onClickCallToAction: (function (param) {
                              router.push("/", undefined, undefined);
                              
                            }),
                          children: null
                        }, React.createElement(Script, {
                              id: "stripe",
                              src: "https://js.stripe.com/v3/",
                              type_: "text/javascript"
                            }), React.createElement(Head, {
                              children: null
                            }, React.createElement("title", undefined, ReactUtils$SmartcutsMacros.s("Plans | Smartcuts")), typeof window === "undefined" ? React.createElement("style", {
                                    id: "holderStyle",
                                    dangerouslySetInnerHTML: {
                                      __html: "*, *::before, *::after {transition: none!important;}"
                                    }
                                  }) : null, React.createElement("link", {
                                  href: "/favicon-16.png",
                                  rel: "icon",
                                  sizes: "16x16",
                                  type: "image/png"
                                }), React.createElement("link", {
                                  href: "/favicon-32.png",
                                  rel: "icon",
                                  sizes: "32x32",
                                  type: "image/png"
                                }), React.createElement("link", {
                                  href: "/favicon-96.png",
                                  rel: "icon",
                                  sizes: "96x96",
                                  type: "image/png"
                                })), React.createElement(Antd.Layout, {
                              className: page,
                              children: React.createElement("section", {
                                    className: "pageContent"
                                  }, React.createElement("section", {
                                        className: "headline"
                                      }, React.createElement("h1", undefined, ReactUtils$SmartcutsMacros.s("Choose the plan that's right for you")), React.createElement("p", undefined, ReactUtils$SmartcutsMacros.s("And use Smartcuts to automate your work on web"))), tmp)
                            }));
            });
}

function getStaticProps(param) {
  var client = Apollo$SmartcutsMacros.makeClient(undefined, AppConfig$SmartcutsMacros.publicUserToken, undefined);
  return Curry._6(client.rescript_query, {
                query: DataStore__User$SmartcutsMacros.AllServicePlans.query,
                Raw: DataStore__User$SmartcutsMacros.AllServicePlans.Raw,
                parse: DataStore__User$SmartcutsMacros.AllServicePlans.parse,
                serialize: DataStore__User$SmartcutsMacros.AllServicePlans.serialize,
                serializeVariables: DataStore__User$SmartcutsMacros.AllServicePlans.serializeVariables
              }, undefined, undefined, undefined, undefined, undefined).then(function (_response) {
              var apolloStaticCache = client.cache.extract();
              return Promise.resolve(Curry._1(Next$SmartcutsMacros.GetStaticProps.$$Response.makePropsWithRevalidate, {
                              props: {
                                apolloStaticCache: apolloStaticCache
                              },
                              revalidate: Caml_option.some(Curry._1(Next$SmartcutsMacros.GetStaticProps.$$Response.Revalidate.seconds, 60))
                            }));
            });
}

var AllServicePlans;

var MyActiveSubscriptions;

var make = PagePlans;

exports.AllServicePlans = AllServicePlans;
exports.MyActiveSubscriptions = MyActiveSubscriptions;
exports.Style = Style;
exports.PageLoader = PageLoader;
exports.PriceInfoOrBilledStatus = PriceInfoOrBilledStatus;
exports.PlanCard = PlanCard;
exports.AllPlans = AllPlans;
exports.make = make;
exports.getStaticProps = getStaticProps;
/* page Not a pure module */
